import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

const red = '#bb0000';
const grey ='#a2afb9'


const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    fontSize: 20,
    backgroundColor: red,
    zIndex:1,
    color:'#ffffff'
  },
  input: {
    display: 'none',
  },
});
class FinishButton extends Component {
  handleOnClick = () => {
    if (window.confirm('試験を終了します。よろしいですか？')) this.props.onClick()
  }

  render(){
  const { classes } = this.props;
  return (
    <div>
      <Button
        onClick={this.handleOnClick}
        variant="contained"
        color='inherit'
        className={classes.button}
      >
        Finish Quiz
      </Button>
    </div>
  );
}
}


FinishButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(FinishButton);



// WEBPACK FOOTER //
// ./src/components/quiz/QuizButtons/FinishButton.js